import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ standalone: false, name: 'isodate' })
export class IsoDatePipe implements PipeTransform {
  transform(input: string): string {
    const date = new Date(input);

    return date.toLocaleString('de-DE', {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
    });
  }
}
